// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow_modal__WI5Tk","close":"ModalWindow_close__4LfbT","content":"ModalWindow_content__Xxd2O","active":"ModalWindow_active__IA7Rr"};